// extracted by css-extract-rspack-plugin
export default {"block_container":"kD3c0","blockContainer":"kD3c0"};